module.exports = __webpack_public_path__ + "static/media/details3.4a78d584.svg";